import { BaseModel } from "./base"
import { JsonProperty } from "../requests/jsonparser";
import { CategoryMedia } from "./category_media";

export class Category extends BaseModel {

    @JsonProperty({ type: 'false' })
    ISHELPERMODEL: string;
    @JsonProperty({ type: 'Category' })
    MODELNAME: string;


    @JsonProperty({ type: 'string' })
    id: string;

    @JsonProperty({ type: 'string' })
    name: string;

    @JsonProperty({ type: 'string' })
    slug: string;

    @JsonProperty({ type: 'string?' })
    image_url?: string;

    @JsonProperty({ type: 'string?' })
    background_image_url?: string;

    @JsonProperty({ type: 'string?' })
    type?: 'audio' | 'video';

    @JsonProperty({ type: 'number?' })
    position?: number;

    @JsonProperty({ type: 'CategoryMedia[]', required: false, clazz: CategoryMedia })
    media?: CategoryMedia[];

}



// WEBPACK FOOTER //
// ./src/api/src/models/category.ts